import jQuery from "jquery";
import { EVENT } from "../data/constants";
import DATA from "../data/data";
import SERVICE_REGISTRY from "../services/registry";
import { SETTINGS } from "../settings";
import { LocationProvider } from "../stores-js/location/locationprovider";
import templates from "../templates";
import { EventManager, createAutocompleteInput } from "../utils/global";

const $ = jQuery;
export default class SearchView {
    constructor(mainView, filters, brands, autocompleteByName, business) {
        this.selector = "#storemap-searchbar-container";
        this.mainView = mainView;
        this.mapView = mainView.mapView;

        // use for check search POI by id
        this.brands = brands;

        SERVICE_REGISTRY.itinaryService.init(this.mapView);

        this.mainElement = $(this.selector);
        this.mainElement.html(
            templates.mobile.search.render({ ui: total.maps.L10n.ui, itinerary: SETTINGS.itinerary }),
        );

        this.placesViewport = null;
        this.resultStoreSearchById = null;

        // PlaceSearch and TableView for prediction results

        const self = this;

        const topOnLocationChangeCallback = function () {
            const { location } = this.get("details");
            self.placesViewport = this.get("details").viewpoint.bounds;
            const locationText = self.mainElement.find(".storemap-inputbar-input").val();
            const blockSearchNearbyStores = SERVICE_REGISTRY.itinaryService.getDestination() !== null;

            SERVICE_REGISTRY.itinaryService.setOrigin(location);
            SERVICE_REGISTRY.locationService.setLocation(location, locationText, blockSearchNearbyStores);
        };

        let template = templates.mobile.searchInputTop;
        if (business && business.indexOf("b001") > -1) {
            template = templates.mobile.searchInputTopAviation;
        }

        createAutocompleteInput(
            this.mainElement,
            this.mapView.initialBounds,
            template,
            "storemap-searchinput-top-container",
            "storemap-suggestionbar-top-container",
            topOnLocationChangeCallback,
            autocompleteByName,
        );

        createAutocompleteInput(
            this.mainElement,
            this.mapView.initialBounds,
            templates.mobile.searchInputBottom,
            "storemap-searchinput-bottom-container",
            "storemap-suggestionbar-bottom-container",
            function () {
                SERVICE_REGISTRY.itinaryService.setDestination(this.get("location"));
            },
            autocompleteByName,
        );

        // Set filters container html
        this.mainElement.find(".storemap-filtersbar-container").append(SERVICE_REGISTRY.filterService.getTemplate());

        // Datetime picker

        const datetimeContainer = this.mainElement.find(
            "#storemap-alongtheroadfilters-container .storemap-inputbar-container",
        );
        const $departureTimeElement = this.mainElement.find(".storemap-alongtheroad-departure-datetime-input")[0];
        if ($departureTimeElement) {
            datetimeContainer.addClass("storemap-inputbar-container-inactive");
            $departureTimeElement.addEventListener("change", () => {
                if ($departureTimeElement.value !== "") {
                    datetimeContainer.removeClass("storemap-inputbar-container-inactive");
                    const newDate = new Date($departureTimeElement.value);
                    onItinaryDateChange(newDate);
                }
                $departureTimeElement.blur();
            });
            if ($departureTimeElement.value === "") {
                datetimeContainer.addClass("storemap-inputbar-container-inactive");
            }
        }
        // FIXME: restores a datetimepicker
        // $.datetimepicker.setLocale(SETTINGS.language);

        function onItinaryDateChange(selectedDate) {
            const currentDate = new Date();

            if (currentDate > selectedDate) {
                const departureTime = Math.floor(currentDate.getTime() / 1000);
                SERVICE_REGISTRY.itinaryService.setStartDatetime(departureTime);
            } else {
                const departureTime = selectedDate.getTime() / 1000;
                SERVICE_REGISTRY.itinaryService.setStartDatetime(departureTime);
            }
        }
        //FIXME: restores datepicker
        /*
    this.mainElement.find('.storemap-alongtheroad-departure-datetime-input').datetimepicker({
      minDate: 0, // Today
      format: 'd/m/y H:i',
      onShow() {
        datetimeContainer.removeClass('storemap-inputbar-container-inactive');
      },
      onClose() {
        if (self.mainElement.find('.storemap-alongtheroad-departure-datetime-input').val() === '') {
          datetimeContainer.addClass('storemap-inputbar-container-inactive');
        }
      },
      onSelectTime(date) {
        onItinaryDateChange(date);
      },
      onSelectDate(date) {
        onItinaryDateChange(date);
      },
    });
*/
        // Geolocation
        this.woosmapNavigatorGeolocation = new LocationProvider();

        this.woosmapNavigatorGeolocation.location_changed = function () {
            if (this.get("location").source === "html5") {
                const location = this.get("location");
                const blockSearchNearbyStores = SERVICE_REGISTRY.itinaryService.getDestination() !== null;

                SERVICE_REGISTRY.locationService.setLocation(
                    location,
                    total.maps.L10n.ui.common.myLocation,
                    blockSearchNearbyStores,
                );

                SERVICE_REGISTRY.itinaryService.setOrigin(location);

                const inputElement = self.mainElement.find(
                    "#storemap-searchinput-top-container .storemap-inputbar-input",
                );
                if (inputElement.val() === "") {
                    inputElement.val(total.maps.L10n.ui.common.myLocation);
                }
                self.mainElement.find(".storemap-inputbar-clear-button").show();
            }
        };

        this._wireEvents();
    }

    _wireEvents() {
        const self = this;

        function onGeolocalisationButtonClick() {
            self.mainView.getNavigatorLocation((position) => {
                if (position) {
                    // var blockSearchNearbyStores = SERVICE_REGISTRY.itinaryService.getDestination() !== null;
                    // SERVICE_REGISTRY.locationService.setLocation(position);
                    SERVICE_REGISTRY.locationService.setLocation(position, total.maps.L10n.ui.common.myLocation, true);
                }
            });
        }

        function onInputTopClearButton() {
            self.mainView.clearMainLocation();
            SERVICE_REGISTRY.locationService.resetLocation();
            SERVICE_REGISTRY.itinaryService.setOrigin(null);
        }

        function onInputBottomClearButton() {
            self.mainView.clearMainLocation();
            SERVICE_REGISTRY.itinaryService.setDestination(null);
        }

        function onInputSearchChange() {
            const value = $(this).val();
            if (value.length === 0) {
                self.clearSearchInput();
                self.resultStoreSearchById = null;
            } else {
                self.clearSearchInput();
                SERVICE_REGISTRY.storeService.getStoreByIdOrCode(value, (store) => {
                    if (store !== null) {
                        self.resultStoreSearchById = store;
                        self.showResultSearchStoreByIdOrCode(store);
                    }
                });
            }
        }

        function onInputSearchEnterKeydown(event) {
            if (event.which === 13 || event.keyCode === 13) {
                self._selectFirstResultOfSuggestion();
            }
        }

        function onTopSuggestionClick(event) {
            self.mainElement.find("#storemap-searchinput-top-container .storemap-inputbar-input").val($(this).text());
            self._searchClickedEvent();
            event.stopPropagation();
        }

        function onBottomSuggestionClick(event) {
            self.mainElement
                .find("#storemap-searchinput-bottom-container .storemap-inputbar-input")
                .val($(this).text());
            self._searchClickedEvent();
            event.stopPropagation();
        }

        function onSearchStoreByIdClick() {
            const resultSotreByIdContainer = self.mainElement.find(".storemap-suggestionbar-searchstorebyid-result");
            const storeId = resultSotreByIdContainer
                .find(".storemap-suggestion-item")
                .text()
                .split("/")[0]
                .replace(/\s+/g, "");
            resultSotreByIdContainer.find(".storemap-suggestion-item").text("");
            resultSotreByIdContainer.hide();
            self.mainElement.find(".storemap-suggestionbar-container").hide();

            const store = self.resultStoreSearchById;
            if (store) {
                self.mainView.setStores([store]);
                self.mainView.setSelectedStore(store);
                self.mainView.setStoreDetails(store);
                self.mainView.showDetail();
            }
        }

        function onSearchButtonClick() {
            self._selectFirstResultOfSuggestion();
        }

        function onItiranyCheckBoxClick() {
            self.mainElement.find(".storemap-alongtheroad-parameters-container").toggle(this.checked);
            if (this.checked) {
                EventManager.notify(EVENT.SHOW_ITINARY_PANEL, null);
                SETTINGS.googleDirectionsRequestOptions.provideRouteAlternatives = false;
            } else {
                SERVICE_REGISTRY.itinaryService.setDestination(null);
                SETTINGS.googleDirectionsRequestOptions.provideRouteAlternatives = true;
            }
        }

        function onItinaryCheckOptionsChange() {
            SERVICE_REGISTRY.itinaryService.updateOptions(
                $("#checkbox-avoidHighways").prop("checked"),
                $("#checkbox-avoidTolls").prop("checked"),
                $("#checkbox-avoidFerries").prop("checked"),
            );
        }

        this.mainElement.on("click", ".storemap-inputbar-position-button", onGeolocalisationButtonClick);
        this.mainElement.on(
            "click",
            "#storemap-searchinput-top-container .storemap-inputbar-clear-button",
            onInputTopClearButton,
        );
        this.mainElement.on(
            "click",
            "#storemap-searchinput-bottom-container .storemap-inputbar-clear-button",
            onInputBottomClearButton,
        );
        this.mainElement.on("input", ".storemap-inputbar-input", onInputSearchChange);
        this.mainElement.on("keydown", ".storemap-inputbar-input", onInputSearchEnterKeydown);
        this.mainElement.on(
            "click",
            ".storemap-suggestionbar-searchstorebyid-result .storemap-suggestion-item",
            onSearchStoreByIdClick,
        );
        this.mainElement.on("click", ".storemap-inputbar-enter-button", onSearchButtonClick);
        this.mainElement.on("click", "#along_the_road_option", onItiranyCheckBoxClick);
        this.mainElement.on(
            "click",
            ".storemap-suggestionbar-top-container .woosmap-tableview-container .storemap-suggestion-item",
            onTopSuggestionClick,
        );
        this.mainElement.on(
            "click",
            ".storemap-suggestionbar-top-container .woosmap-tableview-container .storemap-suggestionByName-item",
            onTopSuggestionClick,
        );
        this.mainElement.on(
            "click",
            ".storemap-suggestionbar-bottom-container .woosmap-tableview-container .storemap-suggestion-item",
            onBottomSuggestionClick,
        );
        this.mainElement.on(
            "click",
            ".storemap-suggestionbar-bottom-container .woosmap-tableview-container .storemap-suggestionByName-item",
            onBottomSuggestionClick,
        );
        this.mainElement.on("click", ".storemap-filterdetail-list input", onItinaryCheckOptionsChange);
    }

    onRefreshList() {
        //const center = { lng: this.mapView.tiledView.getMap().getCenter().lng(), lat: this.mapView.tiledView.getMap().getCenter().lat() };
        const center = this.mapView.map.getCenter().toJSON();
        DATA.reverseGeocode(center, (results) => {
            if (results) {
                this.mainElement
                    .find("#storemap-searchinput-top-container .storemap-inputbar-input")
                    .val(results[0].formatted_address);
                SERVICE_REGISTRY.itinaryService.setOrigin(center);
            }
        });
    }

    show() {
        this.mainElement.show();
    }

    hide() {
        this.mainElement.hide();
    }

    clearSearchInput() {
        this.mainView.updateMainLocation(null);

        this.mainElement.find(".storemap-suggestionbar-container").hide();

        /* a checker */
        const resultStoreByIdContainer = this.mainElement.find(".storemap-suggestionbar-searchstorebyid-result");
        resultStoreByIdContainer.hide();
        resultStoreByIdContainer.find(".storemap-suggestion-item").text("");
    }

    showResultSearchStoreByIdOrCode(store) {
        const resultSotreByIdContainer = this.mainElement.find(".storemap-suggestionbar-searchstorebyid-result");

        this.mainElement.find(".storemap-suggestionbar-container").show();
        resultSotreByIdContainer.show();
        this.mainElement.find(".woosmap-tableview-container").empty();

        let text = store.properties.store_id;
        if (store.properties.user_properties.iata_code && store.properties.user_properties.iata_code !== "") {
            text += ` / ${store.properties.user_properties.iata_code}`;
        }
        resultSotreByIdContainer.find(".storemap-suggestion-item").text(text);
    }

    _selectFirstResultOfSuggestion() {
        const storeSearchByIdContainer = this.mainElement.find(".storemap-suggestionbar-searchstorebyid-result");
        const woosmapSuggestionContainer = this.mainElement.find(".woosmap-tableview-container.card_container");

        const storeSearchByIdItem = storeSearchByIdContainer.find(".storemap-suggestion-item");
        const woosmapSuggestionItems = woosmapSuggestionContainer.find(".storemap-suggestion-item");

        this._searchClickedEvent();

        if (storeSearchByIdContainer.is(":visible") && storeSearchByIdItem) {
            $(storeSearchByIdItem[0]).trigger("click");
        } else if (woosmapSuggestionContainer.is(":visible") && woosmapSuggestionItems) {
            $(woosmapSuggestionItems[0]).trigger("click");
        }
    }

    setInputSearchText(text) {
        const inputBarText = text || total.maps.L10n.ui.common.myLocation;

        this.mainElement.find(".storemap-inputbar-input").val(inputBarText);
        this.mainElement.find("#storemap-searchinput-top-container .storemap-inputbar-clear-button").show();
    }

    _searchClickedEvent() {
        const string = $.map(this.mainElement.find("input:checked"), (checkbox) => checkbox.value).join("xxx");
        EventManager.notify(EVENT.SEARCH_CLICKED, string);
    }

    onQueryFilterChange() {
        // only if user add a location to search nearby stores
        if (SERVICE_REGISTRY.locationService.isUserCurrentLocation()) {
            SERVICE_REGISTRY.storeService.updateNearbyStores();
        }
    }

    onLocationChange(location) {
        if (!$.isEmptyObject(location)) {
            const inputElement = this.mainElement.find(".storemap-inputbar-input");

            if (inputElement.val() === "") {
                inputElement.val(total.maps.L10n.ui.common.myLocation);
            }
            this.mainElement.find("#storemap-searchinput-top-container .storemap-inputbar-clear-button").show();
            const newLocation = location;
            newLocation.description = inputElement.val();

            SERVICE_REGISTRY.storeService.setLocation(newLocation);

            setTimeout(() => {
                if (SETTINGS.itinerary) {
                    if (
                        (!$("#along_the_road_option")[0].checked || SERVICE_REGISTRY.itinaryService.getDestination()) &&
                        this.mainView.currentView !== this.mainView.VIEWS.result
                    ) {
                        this.mainView.showMap("store");
                        this.mapView.setSearchBounds(this.placesViewport);
                        this.placesViewport = null;
                        this.mapView.is_center_changed = false;
                    }
                } else if (this.mainView.currentView !== this.mainView.VIEWS.result) {
                    this.mainView.showMap("store");
                    this.mapView.setSearchBounds(this.placesViewport);
                    this.placesViewport = null;
                    this.mapView.is_center_changed = false;
                }
            }, 1000);

            this.mainElement.find(".storemap-suggestionbar-container").hide();
        }
    }
}
